import { TWidgetSettings } from 'types/GlobalWidget'

/** Whether the widget renders its columns as variant options. */
export const hasVariantOptions = (
  settings: Pick<TWidgetSettings, 'variant_options'>
): boolean => (settings.variant_options?.length ?? 0) > 0
